import { DocumentoAllegato } from '../documento-allegato';
import { DataInput } from './data-input';

export class UpdateMetadatiDocumentoRequest {
  documento: DocumentoAllegato;
  dataInput: DataInput;
}
